import React from 'react';
import { Empty, Spin } from 'antd';
import InfoCard from '../../common/InfoCard/InfoCard';
import {
  RoomComments,
  useRoomCommentsQuery,
} from '../../../../../components/RoomComments';
import styles from './CommentInfoCard.module.scss';

const CommentInfoCard = ({ className, dark = false, addressId }) => {
  return (
    <InfoCard title="Комментарии" className={className} dark={dark}>
      <RoomComments hasModal={false} addressId={addressId}>
        <Content dark={dark} />
      </RoomComments>
    </InfoCard>
  );
};

export default CommentInfoCard;

function Content({ dark }) {
  const { data, isFetching } = useRoomCommentsQuery();

  const comments = Array.isArray(data) ? data : [];

  return (
    <Spin spinning={isFetching}>
      {comments.length === 0 ? (
        <>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </>
      ) : (
        <div className={styles.container}>
          {comments.map((comment) => (
            <RoomComments.CommentCard
              key={comment.id}
              comment={comment}
              bg={dark ? '#fff' : '#f3f7fc'}
            />
          ))}
        </div>
      )}
    </Spin>
  );
}
